import React from 'react';
import { useTranslation } from 'react-i18next';

import { BasePagination } from './BasePagination';
import styles from './Pagination.module.css';
type PaginationProps = {
  children: React.ReactElement[];
  navKey?: 'sheet' | 'material' | 'packet';
};
export const Pagination = ({ children, navKey = 'sheet' }: PaginationProps) => {
  const { t } = useTranslation();
  const container = React.useRef<HTMLDivElement>(null);
  const [page, setPage] = React.useState(1);
  const pages = React.Children.count(children);

  React.useEffect(() => {
    const isEmpty = pages === 0;
    const isOutOfBounds = page > pages;

    if (isEmpty || isOutOfBounds) {
      setPage(1);
      return;
    }
  }, [page, pages]);

  // Only render the currently visible child for better performance
  const childrenArray = React.Children.toArray(children);
  const currentChild = childrenArray[page - 1] as
    | React.ReactElement
    | undefined;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content} ref={container}>
        {currentChild}
      </div>
      {pages > 1 && (
        <div className={styles.navigationWrapper}>
          <p>{t(`translation.pagination.${navKey}`, { page, pages })}</p>
          <BasePagination
            totalPages={pages}
            currentPage={page}
            onPageChanged={setPage}
          />
        </div>
      )}
    </div>
  );
};
